module.exports = __webpack_public_path__ + "static/media/SpacerVideo.ebc6acfd.mp4";